export default "__VITE_ASSET__BGNqLEd4__"